<template>
    <div class="wrap">
        <h3>{{$t("validate.bio")}}</h3>
        <div class="content-wrap">
            <div class="avatar-wrap">
                <div class="image-wrap" :class="{active: avatar}">
                    <img :src="currentImage" alt="avatar" v-if="!isCropping" @click="handleFile">
                    <vue-croppie ref="croppieRef" :enable-resize="false" :boundary="{ width: 150, height: 150}" :viewport="{ width:150, height:150, 'type':'square' }" v-else/>
                </div>
                <div class="file-input button-round" :class="{'change': avatar}" @click="handleFile" v-if="!isCropping">
                    {{avatar ? $t('button.remove') : $t('button.upload')}}
                    <span class="material-icons" v-if="!avatar">cloud_upload</span>
                    <span class="material-icons" v-else>delete</span>
                    <input type="file" ref="fileInput" @change="handleGetFile">
                </div>
                <div class="button-round crop" @click="crop" v-else>
                    {{$t('button.crop')}}
                    <span class="material-icons">check</span>
                </div>
            </div>
            <div class="bio-wrap">
                <textarea v-model="bioText" cols="30" rows="10"></textarea>
            </div>
        </div>
        <div class="button-wrap">
            <div class="button-round next" @click="handleBio">
                {{$t('button.next')}}
            </div>
        </div>
    </div>
</template>

<script>


export default {

    data () {
        return {
            bioText: '',
            avatar: null,
            isCropping: false
        }
    },
    computed: {
        currentImage () {
            if (!this.avatar) {
                return this.$images.stockAvatar
            }
            return this.avatar
        }
    },
    methods: {
        handleBio () {

            this.$emit('next-bio', { avatar: this.avatar, bioText: this.bioText })
        },
        handleFile () {
            if (this.avatar) {
                this.avatar = null
                return
            }
            this.$refs.fileInput.click()
        },
        handleGetFile (e) {
            console.log(e)
            const fr = new FileReader()
            fr.onload = (e) =>{
                this.isCropping = true
                this.$nextTick(()=>{
                    this.$refs.croppieRef.bind({
                        url: e.target.result
                    });

                })
            } 
            fr.readAsDataURL(e.target.files[0])
        },
        crop () {
            this.$refs.croppieRef.result({
                type: 'base64',
                size: {width: 150, height: 150},
                format: 'jpeg'
            }, result => {
                this.avatar = result
                this.isCropping = false
            }
            )
        }
    }
}
</script>

<style scoped lang="scss">
.content-wrap {
    display: flex;
    flex-wrap: wrap;
    min-width: calc(min(100%, 700px));
}
.avatar-wrap {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    margin: 10px;
}
.bio-wrap {
    flex-grow: 2;
}
.image-wrap {
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #E0E0E0;
    width: 150px;
    height: 150px;
    overflow:hidden;
    margin-bottom: 15px;
    &.active {
        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
}
.button-round {
    width: min-content;
}
.crop {
    background: var(--button-color-blue);
    color: #fff;
}
.change {
    background: var(--button-color-bright-red);
    color: #fff;
}
.button-wrap {
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
}
.file-input.button-round {
    position: relative;
    input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
}
.next {
    background: var(--button-color-yellow)
}
textarea {
    font-family: 'Roboto', sans-serif; 
    background: #FFFFFF;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    width: 100%;
    border: none;
    resize: none;
    height: 100%;
    box-sizing: border-box;
}
</style>